{
  "fr": {
    "item": {
      "deleted": "Contenu supprimé"
    }
  }
}
